import { useMemo } from 'react';

import { findMatchedLevelByPoints } from './utils';

import { LevelModel } from 'v2/types/LevelModel';
import { UserModel } from 'v2/types/UserModel';
import { VipLevelModel } from 'v2/types/VipLevelModel';

interface UseComputedUserLevelsArgs {
  user: UserModel;
  vipLevels?: VipLevelModel[];
  levels?: LevelModel[];
}

interface UseComputedUserLevelsReturn {
  vipLevelLabel: string;
  levelLabel: string;
}

export const useComputedUserLevels = ({
  user,
  vipLevels,
  levels,
}: UseComputedUserLevelsArgs): UseComputedUserLevelsReturn => {
  const vipLevelLabel = useMemo(() => {
    const matched = findMatchedLevelByPoints(vipLevels, user.levelVipPoints);

    return matched?.title ?? 'starter';
  }, [vipLevels, user.levelVipPoints]);

  const levelLabel = useMemo(() => {
    const matched = findMatchedLevelByPoints(levels, user.levelPoints);

    return String(matched?.level ?? 0);
  }, [levels, user.levelPoints]);

  return { vipLevelLabel, levelLabel };
};
